import { Grid } from "@mui/material";

import { useResendCode } from "../../SMSCodeStep/useResendCode";

import { DashboardButton } from "@/dashboard-design-system/DashboardButton";

export const ResendCodeButton = () => {
  const {
    isResendButtonDisabled,
    resendButtonCountdownText,
    resendCode,
    isLoadingSendSms: isLoadingResendSms,
  } = useResendCode({});

  return (
    <Grid item>
      <DashboardButton
        onClick={resendCode}
        vibe="brand"
        variant="outlined"
        fullWidth
        isLoading={isLoadingResendSms}
        disabled={isResendButtonDisabled}
      >
        <span>{resendButtonCountdownText}</span>
      </DashboardButton>
    </Grid>
  );
};
